import { useState, useCallback } from 'react';
import type { UserOverview } from '~/common/types/user-overview';

export const useLocalHooks = (user: UserOverview) => {
  const [isFollow, setFollow] = useState(false);
  const [followersCount, setFollowersCount] = useState(user.followerCount || 0);

  const onFollowSucceed = useCallback(() => {
    if (!isFollow) {
      setFollow(true);
      setFollowersCount(followersCount + 1);
    }
  }, [followersCount, isFollow]);

  const onUnfollowSucceed = useCallback(() => {
    setFollow(false);
    setFollowersCount(followersCount > 0 ? followersCount - 1 : 0); // shouldn't happen but just in case
  }, [followersCount]);

  return {
    followersCount,
    onFollowSucceed,
    onUnfollowSucceed,
  };
};
